import React from 'react';
import '../../styling/Pages/Subscriptions.css'

const Subscriptions = () => {
    return (
        <>
            <p>You are on the Subscriptions page</p>
        </>
    );
}

export default Subscriptions;